<template>
  <div id="data-view">
    <div class="dv-full-screen-container ">
      <div style="height:100%;width:100%;">
        <!--video autoplay loop muted preload
          style="position: absolute;top: 100px;left:0px;z-index: -2;filter: blur(1px);width: 100%;height: 100%;">
          <source src="../../assets/b.mp4" type="video/mp4">
          您的浏览器不支持Video标签。
        </video-->


        <div class="main-header">
          <div class="mh-left">
            <div style="width: 255px; height: 80px; line-height: 80px; text-align:center;margin-left:20px;">
              <router-link to="/system">
                <img src="../../assets/logocw.png" height="80" width="240" alt="hexagon" />
              </router-link>
            </div>
          </div>


          <div class="mh-middle">
            <dv-decoration-8
              style="height:70px;margin-bottom: 5px; width: 300px; background-image: url('./img/1.png'); background-size: 100% 100%;" />
            <div style="margin: auto;display: block;">

              <div style=" width: 100%;  display: flex  ">
                <div style="margin: 0 auto;">海克斯康智慧园区平台系统</div>
              </div>
              <dv-decoration-5 style="width:380px;height:50px;" />
            </div>
            <dv-decoration-8 :reverse="true" style="height:70px;width: 300px; margin-bottom: 5px;" />
          </div>


          <div class="mh-right">
            <!--div style="width: 180px; height: 80px; line-height: 50px; text-align:center;margin-left:50px;">机床1</div-->
            <div
              style="float:right; width: 200px; height: 100px; line-height: 10px; text-align:center;cursor: pointer; display: flex;   justify-content: flex-end ;   align-items: flex-end;">

              <dv-decoration-11 style="width:200px;height:100px; align-items: flex-end;">
                <div style="width:100%;height:100%;display:flex;justify-content: center;;align-items: center;"
                  v-on:click="MachineClick()">
                  <span>
                    {{ location[lindex].name }}
                  </span>
                </div>
              </dv-decoration-11>
            </div>
          </div>
        </div>

        <dv-border-box-1 class="main-container—home" :class="{ disImg: lindex == 0, undisImg: lindex != 0 }"
          v-if="lindex == 0" id="ttyt" >
          <div class="right-main-container-home"  id="tempid1">
            <dv-border-box-7 class="rm-top-container">
              <div style="width: 100%;">
                <div class="chart-table1">
                  <div v-for="itemr in sensorTempratureItems" class="item">
                    <TempCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="1" :id="itemr[0]" :mode=lindex
                      :refresh="reffesh" />
                  </div>

                </div>
                <div class="chart-table2">
                  <div v-for="itemr in sensorWaterItems" class="item">
                    <WaterCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="2" :id="itemr[0]" :mode=lindex />
                  </div>
                </div>
              </div>
            </dv-border-box-7>
          </div>
        </dv-border-box-1>



        <dv-border-box-1 class="Temp-container" v-if="lindex == 1" style="margin: auto; ">
          <div class="right-main-container" style="margin: auto; " id="tempid1">
            <div class="" style=" margin: auto;" >
              <dv-border-box-7 class="rm-top-container">
                <div v-for="itemr in disTemp1" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <TempCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="1" :id="itemr[0]" :mode=lindex
                    :refresh="reffesh" />
                </div>

                <img :class="{ disImg: lindex == 1, undisImg: lindex != 1 }" src="../../assets/n1.png" height="811"
                  width="957" alt="hexagon" id="bi1"
                  style="object-fit: cover; position: absolute; left:500px; top: 0px;margin-left: -480px;margin-top: 120px;" />
              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>

        <dv-border-box-1 class="Temp-container" v-if="lindex == 2">
          <div class="right-main-container" id="tempid1">
            <div class="">
              <dv-border-box-7 class="rm-top-container">

                <div v-for="itemr in disTemp2" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <TempCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="1" :id="itemr[0]" :mode=lindex
                    :refresh="reffesh" />
                </div>
                <img :class="{ disImg: lindex == 2, undisImg: lindex != 2 }" src="../../assets/n2.png" height="732"
                  width="1475" alt="hexagon" id="bi2"
                  style="object-fit: cover; position: absolute; left:500px;top: 0px; margin-left: -730px;margin-top: 120px;" />

              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>

        <dv-border-box-1 class="Temp-container" v-if="lindex == 3">
          <div class="right-main-container" id="tempid1">
            <div class="">
              <dv-border-box-7 class="rm-top-container">

                <div v-for="itemr in disTemp3" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <TempCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="1" :id="itemr[0]" :mode=lindex
                    :refresh="reffesh" />
                </div>
                <img :class="{ disImg: lindex == 3, undisImg: lindex != 3 }" src="../../assets/n3.png" height="732"
                  width="1475" alt="hexagon" id="bi2"
                  style="object-fit: cover; position: absolute; left:500px; top: 0px; margin-left: -730px;margin-top: 120px;" />

              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>

        <dv-border-box-1 class="Temp-container" v-if="lindex == 4">
          <div class="right-main-container" id="tempid1">
            <div class="">
              <dv-border-box-7 class="rm-top-container">
                <div v-for="itemr in disWater4" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <WaterCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="2" :id="itemr[0]" :mode=lindex />
                </div>

                <img :class="{ disImg: lindex == 4, undisImg: lindex != 4 }" src="../../assets/n1.png" height="811"
                  width="957" alt="hexagon" id="bi4"
                  style="object-fit: cover; position: absolute; left:500px; top: 0px;; margin-left: -480px;margin-top: 120px;" />
              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>

        <dv-border-box-1 class="Temp-container" v-if="lindex == 5">
          <div class="right-main-container" id="tempid1">
            <div class="">
              <dv-border-box-7 class="rm-top-container">

                <div v-for="itemr in disWater5" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <WaterCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="2" :id="itemr[0]" :mode=lindex />
                </div>


                <img :class="{ disImg: lindex == 5, undisImg: lindex != 5 }" src="../../assets/n2.png" height="732"
                  width="1475" alt="hexagon" id="bi3"
                  style="object-fit: cover;  position: absolute; left:500px; top: 0px; margin-left: -730px;margin-top: 120px;" />


              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>

        <dv-border-box-1 class="Temp-container" v-if="lindex == 6">
          <div class="right-main-container" id="tempid1">
            <div class="">
              <dv-border-box-7 class="rm-top-container">


                <div v-for="itemr in disWater6" class="item2" :style="{ top: itemr[4] + 'px', left: itemr[5] + 'px' }" style="margin-left: -480px;">
                  <WaterCharts :oee="itemr[3]" :chartname="itemr[1]" :shap="2" :id="itemr[0]" :mode=lindex />
                </div>


                <img :class="{ disImg: lindex == 6, undisImg: lindex != 6 }" src="../../assets/n3.png" height="736"
                  width="736" alt="hexagon" id="bi4"
                  style="object-fit: cover;position: absolute; left:930; top: 0px; margin-left: -360px;margin-top: 120px;" />
              </dv-border-box-7>
            </div>
          </div>
        </dv-border-box-1>




      </div>
    </div>
  </div>
</template>

<script>
import CenterCmp from './CenterCmp'
import RightChart1 from './RightChart1'
import RightChart2 from './RightChart2'
import BottomCharts from './BottomCharts'
import WaterCharts from './WaterCharts'
import BodeCharts from './BodeCharts'
import TempCharts from './TempCharts'
export default {
  name: 'DataView',
  components: {
    CenterCmp,
    RightChart1,
    RightChart2,
    BottomCharts,
    BodeCharts,
    WaterCharts,
    TempCharts
  },
  data() {
    return {
      refreshTime: 3,
      urlhexagonSensors: 'http://42.194.135.254:10081/hexagonSensors',

      full: false,

      sensorTempratureItems: [],
      sensorWaterItems: [],
      lindex: 0,
      reffesh: 0,
      pscale: 0,
      version: '2.0.0.20241021',
      disTemp1: [],
      disTemp2: [],
      disTemp3: [],
      disWater4: [],
      disWater5: [],
      disWater6: [],
      location: [
        { id: 0, name: '所有传感器' },
        { id: 1, name: '101 温度' },
        { id: 2, name: '102-103 温度' },
        { id: 3, name: '104 温度' },
        { id: 4, name: '101 湿度' },
        { id: 5, name: '102-103 湿度' },
        { id: 6, name: '104 湿度' },

      ],

      sensorNamesPlus2: [ // name alias category value x y

        ["temperature_humidity4144", "101-3西北角", "101", 0, 600, 600, 1],
        ["temperature_humidity3144", "101-3报告厅", "101", 0, 600, 750, 2],
        ["temperature_humidity2144", "101-3空调机房", "101", 0, 750, 600, 3],
        ["temperature_humidity1144", "101-3东南角", "101", 0, 750, 750, 4],

        ["temperature_humidity6143", "101-1东空调机房", "101", 0, 70, 1100, 5],
        ["temperature_humidity5143", "101-1北空调机房", "101", 0, 170, 750, 6],
        ["temperature_humidity4143", "101-2东空调机房", "101", 0, 200, 1100, 7],
        ["temperature_humidity3143", "101-2北空调机房", "101", 0, 300, 750, 8],

        ["temperature_humidity3184", "101一层", "101", 0, 450, 600, 9],
        ["temperature_humidity2184", "101二层", "101", 0, 450, 750, 10],
        ["temperature_humidity1184", "101三层", "101", 0, 450, 900, 11],


        //----------------------------



        ["temperature_humidity1150", "103-2北侧书柜", "102-103", 0, 250, 1000, 1],
        ["temperature_humidity2150", "103-3儿童角", "102-103", 0, 250, 1150, 2],
        ["temperature_humidity3150", "103-4跑步机", "102-103", 0, 250, 1300, 3],
        ["temperature_humidity6148", "103-1走廊东侧", "102-103", 0, 250, 1450, 4],

        ["temperature_humidity5148", "103-1洗手台", "102-103", 0, 400, 1200, 5],
        ["temperature_humidity4148", "103-1走廊西侧", "102-103", 0, 400, 850, 6],


        ["temperature_humidity6147", "102-6楼顶热水间", "102-103", 0, 600, 600, 7],
        ["temperature_humidity5147", "102-6楼顶热水间", "102-103", 0, 600, 750, 8],


        ["temperature_humidity4145", "102-1大堂", "102-103", 0, 250, 250, 9],
        ["temperature_humidity2145", "102-1卫生间", "102-103", 0, 250, 550, 10],
        ["temperature_humidity1145", "102-1急救室", "102-103", 0, 250, 400, 11],
        ["temperature_humidity5144", "102-5西空调机房", "102-103", 0, 400, 400, 12],


        //----------------------------
        ["temperature_humidity6142", "104-2西外机机房", "104", 0, 600, 500, 1],
        ["temperature_humidity5142", "104-2卫生间", "104", 0, 730, 500, 2],
        ["temperature_humidity4142", "104-2新风机房", "104", 0, 600, 650, 3],

        ["temperature_humidity6149", "104-2东空调机房", "104", 0, 600, 1200, 4],
        ["temperature_humidity2149", "104-2东空调机房", "104", 0, 730, 1200, 5],
        ["temperature_humidity1149", "104-2东空调机房", "104", 0, 470, 1200, 6],

        ["temperature_humidity6146", "104-1物流区东北角", "104", 0, 100, 1200, 7],
        ["temperature_humidity5146", "104-1物流区大门", "104", 0, 150, 1050, 8],
        ["temperature_humidity4146", "104-1物流区", "104", 0, 100, 900, 9],
        ["temperature_humidity1146", "104-1收货区", "104", 0, 100, 750, 10],


        ["1213213", "园区温度传感器0001", "", 0, 200, 500, 1],

        //----------------------------
        //----------------------------
        //----------------------------

        ["water20144", "101-3西北角", "101", 0, 400, 550, 1],
        ["water23144", "101-3东南角", "101", 0, 400, 700, 2],
        ["water24184", "101一层", "101", 0, 400, 850, 3],

        ["water23184", "101二层", "101", 0, 600, 700, 4],
        ["water22184", "101三层", "101", 0, 750, 700, 5],

        //----------------------------

        ["water25145", "102-1卫生间", "102-103", 0, 200, 450, 7],
        ["water24145", "102-1急救室", "102-103", 0, 200, 300, 8],

        //----------------------------
        ["water21150", "103-2北侧书柜", "102-103", 0, 250, 1000, 1],
        ["water20150", "103-4跑步机", "102-103", 0, 250, 1300, 2],
        ["water19150", "103-3儿童角", "102-103", 0, 250, 1150, 3],
        ["water24148", "103-1走廊东侧", "102-103", 0, 250, 1450, 4],

        ["water23148", "103-1洗手台", "102-103", 0, 400, 1150, 5],
        ["water22148", "103-1走廊西侧", "102-103", 0, 400, 850, 6],

        //----------------------------
        ["water22146", "104-1物流区东北角", "104", 0, 100, 1250, 1],
        ["water25146", "104-1物流区大门", "104", 0, 150, 1100, 2],
        ["water21146", "104-1物流区", "104", 0, 100, 950, 3],
        ["water19146", "104-1收货区", "104", 0, 100, 800, 4],
      ],

    }

  },
  mounted() {
    let _this = this;

    let interval = this.$data.refreshTime * 1000;
    _this.load();
    this.timer =
      setInterval(() => {
        _this.updatePlus();
      }, interval);
    console.log('version:' + this.version);
    console.log('完成了数据加载');

    this.adjustSize();

    window.onresize = function () {
      // console.log("agag")
      return (() => {
        _this.adjustSize();
      })();
    };

  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    console.log('全都销毁了');
  },
  methods: {
    load() {
      this.initPlus();
      this.updatePlus();

    },
    adjustSize() {
        window.screenWidth = document.body.clientWidth;
        var screenWidth = window.screenWidth;

        var pscale = screenWidth / 1600;
        if(pscale>1)pscale = 1;
        if(this.lindex==0)pscale = 1;
        var tt=document.getElementById("tempid1")
        if(tt)
          tt.style.transform = "scale(" + pscale + ")";
          console.log('完成了数据加载-------------' + pscale);
    },
    MachineClick() {
      let _this = this;

      this.lindex++;
      if (this.lindex == 7) this.lindex = 0;

      this.updatePlus();
      this.adjustSize();
    },
    updatePlus() {
      let _this = this;

      //-----------------------------
      this.$http.get(this.$data.urlhexagonSensors, {
        params: {}
      })
        .then(function (response) {

          //_this.sensorTempratureItems.length = 0
          //_this.sensorWaterItems.length = 0
          //_this.disTemp.length = 0
          //_this.disWater.length = 0
          console.log("-------------------------")
          console.log(response.data)
          console.log(response.status)
          console.log(response.statusText)
          console.log(response.headers)
          console.log(response.config)
          console.log("-------------------------")
          let data = response.data;

          for (let index = 0; index < _this.sensorNamesPlus2.length; index++) {
            const element = _this.sensorNamesPlus2[index];
            data.forEach(d => {
              let name = d.sensorname;
              if (name == element[0]) {
                element[3] = d.value
              }
            }
            );
          }



          for (let index = 0; index < _this.sensorNamesPlus2.length; index++) {
            const element = _this.sensorNamesPlus2[index];
            if (index < 33)
              _this.sensorTempratureItems[index] = (element)
            else if (index > 33)
              _this.sensorWaterItems[index - 33 - 1] = (element)
          };


          let k = 0;
          for (let index = 0; index < _this.sensorTempratureItems.length; index++) {
            const element = _this.sensorTempratureItems[index];
            if (element[2] == "101") {
              _this.disTemp1[k] = (element)
              k++;
            }

          };

          k = 0;
          for (let index = 0; index < _this.sensorTempratureItems.length; index++) {
            const element = _this.sensorTempratureItems[index];
            if (element[2] == "102-103") {
              _this.disTemp2[k] = (element)
              k++;
            }
          };

          k = 0;
          for (let index = 0; index < _this.sensorTempratureItems.length; index++) {
            const element = _this.sensorTempratureItems[index];
            if (element[2] == "104") {
              _this.disTemp3[k] = (element)
              k++;
            }
          };

          k = 0;
          for (let index = 0; index < _this.sensorWaterItems.length; index++) {
            const element = _this.sensorWaterItems[index];
            if (element[2] == "101") {
              _this.disWater4[k] = (element)
              k++;
            }
          };

          k = 0;
          for (let index = 0; index < _this.sensorWaterItems.length; index++) {
            const element = _this.sensorWaterItems[index];
            if (element[2] == "102-103") {
              _this.disWater5[k] = (element)
              k++;
            }
          };

          k = 0;
          for (let index = 0; index < _this.sensorWaterItems.length; index++) {
            const element = _this.sensorWaterItems[index];
            if (element[2] == "104") {
              _this.disWater6[k] = (element)
              k++;
            }
          };



          if (_this.reffesh == 0)
            _this.reffesh = 1
          else if (_this.reffesh == 1)
            _this.reffesh = 0


          _this.$forceUpdate();
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    initPlus() {
      let _this = this;



      for (let index = 0; index < _this.sensorNamesPlus2.length; index++) {
        const element = _this.sensorNamesPlus2[index];
        if (index < 33)
          _this.sensorTempratureItems.push(element)
        else if (index > 33)
          _this.sensorWaterItems.push(element)
      };





      for (let index = 0; index < _this.sensorTempratureItems.length; index++) {
        const element = _this.sensorTempratureItems[index];
        if (element[2] == "101") {
          element[0] = element[0] + ""
          _this.disTemp1.push(element)
        }
        if (element[2] == "102-103") {
          element[0] = element[0] + ""
          _this.disTemp2.push(element)
        }
        if (element[2] == "104") {
          element[0] = element[0] + ""
          _this.disTemp3.push(element)
        }

      };

      for (let index = 0; index < _this.sensorWaterItems.length; index++) {
        const element = _this.sensorWaterItems[index];
        if (element[2] == "101") {
          element[0] = element[0] + ""
          _this.disWater4.push(element)
        }
        if (element[2] == "102-103") {
          element[0] = element[0] + ""
          _this.disWater5.push(element)
        }
        if (element[2] == "104") {
          element[0] = element[0] + ""
          _this.disWater6.push(element)
        }
      };




      if (_this.reffesh == 0)
        _this.reffesh = 1
      else if (_this.reffesh == 1)
        _this.reffesh = 0


      _this.$forceUpdate();

    }

  }
}

</script>

<style lang="less">
#data-view {
  width: 100%;
  min-width: 1180px;
  height: auto;
  min-height: 1200px;
  background-color: #00010a;
  color: #fff;

  .dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;

    -webkit-transform-origin: left top;
    transform-origin: left top;
    z-index: 999;
    min-width: 1180px;
    width:  100%;
    height: auto;

  }

  .main-header {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .mh-left {
      font-size: 20px;
      color: rgb(1, 134, 187);

      a:visited {
        color: rgb(1, 134, 187);
      }
    }

    .mh-middle {
      font-size: 30px;
      width: 640px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

    }


    .mh-right {
      width: 200px;
    }
  }

  .main-container—home {
    height: auto;

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }


  .Temp-container {
    height: auto;


  }


  .right-main-container {
    width: 1000px;
    min-height: 1202px;
    padding-left: 5px;
    box-sizing: border-box;
    margin: auto;
    background-color: transparent;
    transform-origin: center;


  }

  .right-main-container-home {
    min-width: 1000px;
    width: 100%;
    height: 1602px;

  }



  .chart-table {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: repeat(10, 1fr);
    //grid-gap: 2px;
    // grid-gap: 1px solid #37a2da;
  }

  .chart-table1 {
    width: 100%;
    height: 1000px;
    display: grid;
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: repeat(7, 1fr);
    //grid-gap: 2px;
    // grid-gap: 1px solid #37a2da;
  }


  .chart-table2 {
    width: 100%;
    height: 550px;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(7, 1fr);
    //grid-gap: 2px;
    // grid-gap: 1px solid #37a2da;
  }


  .item {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .item2 {
    height: 130px;
    width: 150px;
    box-sizing: border-box;
    position: absolute;
    justify-content: center;
    align-items: center;
    z-index: 5
  }


  .rm-top-container {
    height: 100%;
    min-height: 1200px;
  }

  .disImg {
    display: block;
  }


  .undisImg {
    display: none;
  }
}
</style>
